import { render, staticRenderFns } from "./appCourse.vue?vue&type=template&id=b9af9962&scoped=true&"
import script from "./appCourse.vue?vue&type=script&lang=js&"
export * from "./appCourse.vue?vue&type=script&lang=js&"
import style0 from "./appCourse.vue?vue&type=style&index=0&id=b9af9962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9af9962",
  null
  
)

export default component.exports